import { PracticalItem, ICertificationDetail } from '@/interface'
import { Commit } from 'vuex'
import { getCertificateDetailByInvite } from '@/request/api/invitation'
import { getPracticalExamByCertificate } from '@/request/api/certification'
import { IResponseData } from '~/typings'

const state = {
  dataList: [] as PracticalItem[],
  certificationDetail: {} as ICertificationDetail
}

export type InvitationState = typeof state

const invitationStore = {
  namespaced: true,
  state,
  actions: {
    async getPracticalExam ({ commit }: { commit: Commit }, payload?: { invitationCode?: string }) {
      const res = await getCertificateDetailByInvite(payload?.invitationCode || '') as IResponseData
      const detail = res.data as ICertificationDetail

      commit('setCertificationDetail', detail)

      if (detail?.certificationId) {
        const res = await getPracticalExamByCertificate({ certificationId: detail.id, regionId: '' })
        commit('setPracticalDataList', res.data)
      }
    }
  },
  mutations: {
    setCertificationDetail (state: InvitationState, detail: ICertificationDetail) {
      state.certificationDetail = detail
    },
    setPracticalDataList (state: InvitationState, list: PracticalItem[]) {
      state.dataList = list
    }
  }
}

export { invitationStore }
